import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { RoundData } from "../models/round-data.interface";

@Injectable()
export class RoundService {
    private service = inject(ApiDataService);

    /**
     * creates a new round
     * @param data for round creation
     */
    create(data: RoundData): Observable<boolean> {
        return this.service.post<boolean>('rounds/create', data);
    }

    /**
     * updates an existing round
     * @param data for round update
     */
    update(data: RoundData): Observable<boolean> {
        return this.service.put<boolean>('rounds/update', data);
    }

    /**
     * Gets the display results status of the desired round
     * @param id the id of the desired round
     * @returns display results status
     */
    public getDisplayResultsStatus(id: number): Observable<boolean> {
        return this.service.get<boolean>('rounds/get-results-status/' + id);
      }
    
    /**
     * Updates the display results status of the desired round
     * @param id the id of the desired round
     */
    public updateResultsStatus(id: number): Observable<void> {
      return this.service.patchEmpty<void>('rounds/update-results-status/' + id);
    }
}